import React, { useEffect, useMemo, useState } from "react";
import "./BookingCardStaff.css";

const BookingCardStaff = () => {
  const [nameInput, setNameInput] = useState("");
  const [instituteInput, setInstituteInput] = useState("");
  const [enrolmentInput, setEnrolmentInput] = useState("");
  const [authorized, setAuthorized] = useState(
    () => sessionStorage.getItem("bookingCardAuth") === "ok"
  );

  const displayName = nameInput.trim();
  const displayInstitute = instituteInput.trim();
  const displayEnrolment = enrolmentInput.trim();
  const [qrServiceIndex, setQrServiceIndex] = useState(0);

  const qrServices = useMemo(
    () => [
      "https://api.qrserver.com/v1/create-qr-code/",
      "https://quickchart.io/qr",
    ],
    []
  );

  const qrSrc = useMemo(() => {
    if (!displayEnrolment) return "";
    const encoded = encodeURIComponent(displayEnrolment);
    if (qrServiceIndex === 0) {
      return `${qrServices[0]}?size=220x220&data=${encoded}`;
    }
    return `${qrServices[1]}?size=220&text=${encoded}`;
  }, [displayEnrolment, qrServiceIndex, qrServices]);


  const requestAccess = () => {
    const username = window.prompt("Username");
    const password = window.prompt("Password");
    if (username === "print" && password === "P^1973") {
      sessionStorage.setItem("bookingCardAuth", "ok");
      setAuthorized(true);
      return;
    }
    setAuthorized(false);
  };

  useEffect(() => {
    if (!authorized) {
      requestAccess();
    }
  }, []);

  useEffect(() => {
    setQrServiceIndex(0);
  }, [displayEnrolment]);

  if (!authorized) {
    return (
      <div className="booking-card-staff-locked">
        <div className="booking-card-staff-locked-card">
          <h2>Access required</h2>
          <p>Enter username and password to view the card.</p>
          <button
            className="btn btn-primary"
            type="button"
            onClick={requestAccess}
          >
            Unlock
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="booking-card-staff-page">
      <div className="booking-card-staff-wrap">
        <div className="booking-card-staff-title">ICAB Identity Card</div>
        <div className="booking-card-staff-actions">
          <form
            className="booking-card-staff-form"
            onSubmit={(event) => event.preventDefault()}
          >
            <input
              className="booking-card-staff-input"
              type="text"
              placeholder="Member name"
              value={nameInput}
              onChange={(event) => setNameInput(event.target.value)}
            />
            <input
              className="booking-card-staff-input"
              type="text"
              placeholder="Institute"
              value={instituteInput}
              onChange={(event) => setInstituteInput(event.target.value)}
            />
            <input
              className="booking-card-staff-input"
              type="text"
              inputMode="numeric"
              placeholder="Enrolment/ID"
              value={enrolmentInput}
              onChange={(event) => setEnrolmentInput(event.target.value)}
            />
          </form>
          <button
            className="btn btn-primary booking-card-staff-print"
            type="button"
            onClick={() => window.print()}
          >
            Print
          </button>
        </div>
        <div className="booking-card-staff-grid">
          <section
            className="print-page-staff"
            aria-label="Printable front page"
          >
            <div
              className="id-card-staff id-card-staff-front"
              aria-label="ICAB ID card front"
            >
              {/* <div className="id-card-staff-band"></div> */}
              <div className="id-card-staff-body">
                <div className="id-card-staff-name id-card-staff-name-only">
                  <strong>{displayName || 'Member Name'}</strong>
                  {displayInstitute && (
                    <span className="id-card-staff-institute">
                      {displayInstitute}
                    </span>
                  )}
                </div>
              </div>
              {/* <div className="id-card-staff-footer">Institute of Chartered Accountants of Bangladesh</div> */}
            </div>
          </section>

          <section
            className="print-page-staff"
            aria-label="Printable back page"
          >
            <div className="id-card-staff" aria-label="ICAB ID card back">
              {/* <div className="id-card-staff-band"></div> */}
              <div className="id-card-staff-body">
                <div className="id-card-staff-back-header"></div>
                {displayEnrolment && (
                  <div className="id-card-staff-qr id-card-staff-qr-top">
                    <img
                      src={qrSrc}
                      alt={`QR ${displayEnrolment}`}
                      onError={() => {
                        setQrServiceIndex(
                          (prev) => (prev + 1) % qrServices.length
                        );
                      }}
                    />
                  </div>
                )}
                <div className="id-card-staff-back-grid gap-30-staff">
                  <div>
                    <span className="id-card-staff-date">17 January 2026</span>
                  </div>
                  &nbsp;
                  <div>Le Meridien, Dhaka.</div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default BookingCardStaff;
